// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".feed-post__header{--photo-width:40px;--photo-height:40px}.feed-post__title{font-size:15px;font-weight:500;margin-bottom:4px}.feed-post__content{padding-top:16px}.feed-post__date{color:#6c6c6c;font-size:13px;line-height:20px;margin-top:8px}.feed-post .show-more__container>div{word-break:break-word}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
